import { connect } from 'react-redux';

import { LazyLoadCarousel, ILazyLoadCarouselProps } from '../../components/Carousel/LazyLoadCarousel';
import { getCarouselMedia } from '../../selectors/carousel';
import { IState } from '../../store';

export type TCarouselStoreProps = Pick<ILazyLoadCarouselProps, 'media'>;

export function mapStateToProps(state: IState): TCarouselStoreProps {
  return {
    media: getCarouselMedia(state),
  };
}

export const CarouselContainer = connect<TCarouselStoreProps>(mapStateToProps)(LazyLoadCarousel);
